export { Card } from "@mantine/core";
export type { CardProps } from "@mantine/core";
export { getCardOverrides } from "./Card.styled";
